<template>
  <div class="fail">
    <div class="box">
      <img src="~@/assets/image/register/registr_fail.png" alt="">
      <div class="title">申请失败</div>
      <div class="text">
        <div class="msg">您提交的申请审核失败</div>
        <div class="msg">原因：{{ checkReason }}</div>
      </div>
      <div class="remind"><router-link to="/register">重新申请</router-link></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fail",
  data() {
    return {
      checkReason: ''
    }
  },
  created(){
    this.checkReason = sessionStorage.getItem('checkReason') || '';
  }
};
</script>

<style scoped lang='less'>
.fail{
  min-height: 100vh;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  .box{
    img{
      display: block;
      margin: 0 auto;
      width: 2.546667rem * 2;
    }
    .title{
      font-size: .64rem;
      line-height: 1;
      margin: .453333rem * 2 0 .186667rem;
    }
    .text{
      color: rgba(58, 62, 92, .5);
      font-size: .32rem;
      line-height: .306667rem * 2;
    }
    .remind{
      line-height: 1;
      margin-top: 1.333333rem;
      color: rgba(58, 62, 92, .5);
      font-size: .373333rem;
      a{
        color: rgba(0, 103, 221, .5);
      }
    }
  }
}
</style>
